"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chooseColorVariation = void 0;
var choosePrimaryActionVariation = function (variation, theme) {
    switch (variation) {
        case 'pure':
            return theme.PrimaryActionColorPure;
        case 'high':
            return theme.PrimaryActionColorHigh;
        case 'low':
            return theme.PrimaryActionColorLow;
        default:
            return theme.PrimaryActionColorPure;
    }
};
var chooseNeutralLightVariation = function (variation, theme) {
    switch (variation) {
        case 'pure':
            return theme.NeutralColorLightPure;
        case 'high':
            return theme.NeutralColorLightHigh;
        case 'low':
            return theme.NeutralColorLightLow;
        default:
            return theme.NeutralColorLightPure;
    }
};
var chooseNeutralDarkVariation = function (variation, theme) {
    switch (variation) {
        case 'pure':
            return theme.NeutralColorDarkPure;
        case 'high':
            return theme.NeutralColorDarkHigh;
        case 'low':
            return theme.NeutralColorDarkLow;
        default:
            return theme.NeutralColorDarkPure;
    }
};
var chooseColorVariation = function (variation, colorPalette, theme) {
    switch (colorPalette) {
        case 'primaryAction':
            return choosePrimaryActionVariation(variation, theme);
        case 'neutralDark':
            return chooseNeutralDarkVariation(variation, theme);
        case 'neutralLight':
            return chooseNeutralLightVariation(variation, theme);
    }
};
exports.chooseColorVariation = chooseColorVariation;
